type ServiceName = string;
type CustomURL = string;

type RenderInputType = {
	uri: string;
	shard: string;
	host: string;
	cloudId: string;
	customURLs: Record<ServiceName, CustomURL> | undefined;
	userContext: string | undefined;
	userId: string | undefined;
	isLivePage: boolean | undefined;
	isBifrostIcRequest?: boolean;
	cookiesConsentToken: string | undefined;
	cookiesFallbackToken: string | undefined;
	cookiesShowBannerToken: string | undefined;
	perimeter: string;
	aggHeaders: { [header: string]: string };
	userAgent: string | undefined;
	persistedStatsigOverrides: Record<string, string> | undefined;
	bifrostCommonRequestHeaders: Record<string, string> | undefined;
	embeddablePageEntityIds: string | undefined;
	tapContext: {
		siteUser?: Record<string, any>;
		site?: Record<string, any>;
		user?: Record<string, any>;
	} | null;
	userLoomPermission: boolean | null;
	monolithAwsRegion: string | null;
	confluenceBrowserStorageControls?: boolean;
	environment?: string;
};

let ssrRenderInputs = {} as RenderInputType;

export function setSSRRenderInputs(inputs: RenderInputType): void {
	ssrRenderInputs = inputs;
}

export function getSSRRenderInputs(): RenderInputType {
	return ssrRenderInputs;
}
